// Types
import type { AxiosInstance } from "axios"
import type { ErrorFetch, SelectOptionType, SuccessFetch } from "types"

const group = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_group is empty")
    }

    return api.get(
      "/productgroup/gencode"
    ).then((res: SuccessFetch<{
      payload: {
        code: string
      }
    }>) => {
      api.post(
        "/productgroup/add",
        {
          "mr_product_group_code": res.data.payload.code,
          "mr_product_group_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_group_id: number
          mr_product_group_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_group_name,
          value: payload.mr_product_group_id.toString()
        })

        resolve(payload.mr_product_group_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_group error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const style = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_style is empty")
    }

    return api.get(
      "/productstyle/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productstyle/add",
        {
          "mr_product_style_code": res.data.payload.code,
          "mr_product_style_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_style_id: number
          mr_product_style_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_style_name,
          value: payload.mr_product_style_id.toString()
        })

        resolve(payload.mr_product_style_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_style error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const colour = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_colour is empty")
    }

    return api.get(
      "/productcolour/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productcolour/add",
        {
          "mr_product_colour_code": res.data.payload.code,
          "mr_product_colour_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_colour_id: number
          mr_product_colour_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_colour_name,
          value: payload.mr_product_colour_id.toString()
        })

        resolve(payload.mr_product_colour_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_colour error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const productCategory = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_category is empty")
    }

    return api.get(
      "/productcategory/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productcategory/add",
        {
          "mr_product_category_code": res.data.payload.code,
          "mr_product_category_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_category_id: number
          mr_product_category_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_category_name,
          value: payload.mr_product_category_id.toString()
        })

        resolve(payload.mr_product_category_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_category error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const material = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_material is empty")
    }

    return api.get(
      "/productmaterial/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productmaterial/add",
        {
          "mr_product_material_code": res.data.payload.code,
          "mr_product_material_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_material_id: number
          mr_product_material_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_material_name,
          value: payload.mr_product_material_id.toString()
        })

        resolve(payload.mr_product_material_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_material error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const size = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_product_size is empty")
    }

    return api.get(
      "/productsize/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productsize/add",
        {
          "mr_product_size_code": res.data.payload.code,
          "mr_product_size_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_product_size_id: number
          mr_product_size_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_product_size_name,
          value: payload.mr_product_size_id.toString()
        })

        resolve(payload.mr_product_size_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_product_size error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const category = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("mr_category_customer is empty")
    }

    return api.get(
      "/categorycustomer/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/categorycustomer/add",
        {
          "category_customer_code": res.data.payload.code,
          "category_customer_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          category_customer_id: number
          category_customer_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.category_customer_name,
          value: payload.category_customer_id.toString()
        })

        resolve(payload.category_customer_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`mr_category_customer error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

const unit = async (
  value: string | null,
  options: {
    addNewOption: (value: SelectOptionType) => void
    api: AxiosInstance
  }
): Promise<string> => {
  // Vars
  const api = options.api

  return new Promise<string>((resolve, reject) => {
    if (value === "") {
      return reject("weight_unit_id is empty")
    }

    return api.get(
      "/productunit/gencode"
    ).then((res: SuccessFetch<{
      payload: { code: string }
    }>) => {
      api.post(
        "/productunit/add",
        {
          "mr_unit_code": res.data.payload.code,
          "mr_unit_name": value,
          "description": ""
        }
      ).then((res: SuccessFetch<{
        payload: {
          mr_unit_id: number
          mr_unit_name: string
        }
      }>) => {
        // Vars
        const payload = res.data.payload

        options.addNewOption({
          label: payload.mr_unit_name,
          value: payload.mr_unit_id.toString()
        })

        resolve(payload.mr_unit_id.toString())
      }).catch((err: ErrorFetch<{}>) => {
        reject(`weight_unit_id error: ${err.response.message}`)
      })
    }).catch(() => {
      reject("Error generating code")
    })
  })
}

export const fetchMaster = { category, colour, group, material, productCategory, size, style, unit }